/**
 * cld-cart-monitor.js
 * カート内の fee item の整合性を保つ。
 *
 * ケース1: 本体（_has_fee）があるのに対応するカラー fee item がない → アラート → 本体削除 → リダイレクト
 * ケース2: fee item があるのに対応する本体がない（本体削除後の残留）→ fee item を自動削除 → リロード
 * ケース3: 本体の数量と色手数料の数量がずれている → 色手数料の数量を自動同期 → リロード
 */

const CLD_ALERT_COLOR =
  '印字カラーの手数料が正しく設定されていません。再度選択してください。';

let cldProcessing = false;

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function removeCartItem(key) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 }),
  });
}

async function updateCartItemQty(key, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity }),
  });
}

function updateCartCountBubble(items) {
  const realCount = (items || [])
    .filter((item) => !(item.properties && item.properties['_fee_for']))
    .reduce((sum, item) => sum + item.quantity, 0);

  document.querySelectorAll('.cart-count-bubble').forEach((el) => {
    const numEl = el.querySelector('[aria-hidden="true"]');
    if (numEl) numEl.textContent = realCount < 100 ? String(realCount) : '';
    const hiddenEl = el.querySelector('.visually-hidden');
    if (hiddenEl) hiddenEl.textContent = String(realCount);
    el.style.visibility = realCount === 0 ? 'hidden' : '';
  });
}

async function checkFeeIntegrity() {
  if (cldProcessing) return;

  const cart = await fetchCart();
  const items = cart.items || [];

  updateCartCountBubble(items);

  // カラー fee items を variantId をキーに収集
  const colorFeeByFor = {}; // variantId -> { key, quantity }

  for (const item of items) {
    const props = item.properties || {};
    const feeFor = props['_fee_for'];
    if (!feeFor) continue;
    colorFeeByFor[feeFor] = { key: item.key, quantity: item.quantity };
  }

  // 本体ラインを収集（カラー fee が必要なものだけ）
  const mainLines = [];
  const mainVariantIds = new Set();
  for (const item of items) {
    const props = item.properties || {};
    if (props['_fee_for']) continue; // fee item はスキップ
    if (props['_has_fee'] !== '1') continue;
    const variantId = String(item.variant_id);
    mainLines.push({
      variantId,
      key: item.key,
      quantity: item.quantity,
      productUrl: item.url ? item.url.split('?')[0] : '/',
    });
    mainVariantIds.add(variantId);
  }

  // ケース2: 孤立した fee item を削除
  const orphanedFeeKeys = Object.entries(colorFeeByFor)
    .filter(([feeFor]) => !mainVariantIds.has(feeFor))
    .map(([, v]) => v.key);

  if (orphanedFeeKeys.length > 0) {
    cldProcessing = true;
    await Promise.all(orphanedFeeKeys.map((key) => removeCartItem(key)));
    window.location.reload();
    return;
  }

  // ケース1 & ケース3: fee 存在チェック＋数量同期
  const qtyUpdates = [];

  for (const line of mainLines) {
    const fee = colorFeeByFor[line.variantId];
    if (!fee) {
      alert(CLD_ALERT_COLOR);
      cldProcessing = true;
      await removeCartItem(line.key);
      window.location.href = line.productUrl;
      return;
    }
    if (fee.quantity !== line.quantity) {
      qtyUpdates.push({ key: fee.key, quantity: line.quantity });
    }
  }

  // 数量同期が必要な場合は一括更新してリロード
  if (qtyUpdates.length > 0) {
    cldProcessing = true;
    await Promise.all(qtyUpdates.map((u) => updateCartItemQty(u.key, u.quantity)));
    window.location.reload();
  }
}

// fetch をインターセプトしてカート変更を検知
const _originalFetch = window.fetch;
window.fetch = function (...args) {
  const promise = _originalFetch.apply(this, args);
  const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
  if (
    !cldProcessing &&
    (url.includes('/cart/change') || url.includes('/cart/update'))
  ) {
    promise.then(() => checkFeeIntegrity()).catch(() => {});
  }
  return promise;
};

// ページロード時に一度チェック
checkFeeIntegrity();
